import React, { useState, useEffect } from 'react'
import { Flame, Clock } from 'lucide-react'

export function HyperfocusCard({ streakDays = 7 }) {
  const [timeLeft, setTimeLeft] = useState(1122) // 18:42 in seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 1200))
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60)
    const s = secs % 60
    return `${m}:${s < 10 ? '0' : ''}${s}`
  }

  const days = [
    { label: 'L', active: true },
    { label: 'M', active: true },
    { label: 'X', active: true },
    { label: 'J', active: true },
    { label: 'V', active: true },
    { label: 'S', active: true },
    { label: 'D', active: true, current: true },
  ]

  return (
    <div className="relative rounded-2xl bg-gradient-to-b from-[#161f30] to-[#0f1522] border border-slate-700/60 p-4 shadow-xl overflow-hidden">
      {/* Glow Effect */}
      <div className="absolute top-0 right-0 w-36 h-36 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" />

      {/* Top Badges */}
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-950/60 border border-emerald-500/40 text-emerald-400 text-[11px] font-bold tracking-wide">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span>MODO HYPERFOCUS ON</span>
        </div>

        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-cyan-950/60 border border-cyan-500/40 text-cyan-300 text-[11px] font-semibold">
          <Clock size={12} className="text-cyan-400" />
          <span>{formatTime(timeLeft)} min XP x2</span>
        </div>
      </div>

      {/* Main Streak Title & Icon */}
      <div className="flex items-center gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-gradient-to-tr from-cyan-600/30 to-blue-500/20 border border-cyan-400/40 flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(6,182,212,0.3)]">
          <Flame size={24} className="text-cyan-400 fill-cyan-400" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-base font-extrabold text-white">Racha de {streakDays} Días</h3>
            <span className="px-2 py-0.5 rounded-full bg-purple-900/60 border border-purple-500/40 text-purple-300 text-[10px] font-bold uppercase tracking-wider">
              Fuego Puro
            </span>
          </div>
          <p className="text-xs text-slate-400 mt-0.5">
            ¡Combo activo! Doble XP en cada victoria...
          </p>
        </div>
      </div>

      {/* Weekday Tracker */}
      <div className="grid grid-cols-7 gap-1.5 pt-1">
        {days.map((d, i) => (
          <div key={i} className="flex flex-col items-center gap-1">
            <span className="text-[11px] font-semibold text-slate-400">{d.label}</span>
            <div
              className={`w-full h-1.5 rounded-full transition-all ${
                d.current
                  ? 'bg-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.8)]'
                  : d.active
                  ? 'bg-cyan-500/60'
                  : 'bg-slate-800'
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
